import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { SITE } from "@/config/site";
import { LogoFull } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0A0C] overflow-hidden">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <LogoFull className="w-64 sm:w-72 h-auto" />
          <p className="mt-6 max-w-sm text-zinc-400">Passione per lo spiedo dal 1998. Polli allo spiedo, salsicce, patate e tutto quello che gira sul fuoco, a Volla.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow">Naviga</p>
          <ul className="mt-5 space-y-3 font-semibold">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-[#FF5500] transition-colors">Home</Link></li>
            <li><Link to="/menu" data-testid="footer-link-menu" className="hover:text-[#FF5500] transition-colors">Menù</Link></li>
            <li><Link to="/contatti" data-testid="footer-link-contatti" className="hover:text-[#FF5500] transition-colors">Contatti</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow">Trovaci</p>
          <ul className="mt-5 space-y-3 text-zinc-300">
            <li>{SITE.address}</li>
            <li><a href={SITE.phoneHref} data-testid="footer-phone" className="hover:text-[#FF5500] transition-colors">{SITE.phoneDisplay}</a> · <a href={SITE.mobileHref} data-testid="footer-mobile" className="hover:text-[#FF5500] transition-colors">{SITE.mobileDisplay}</a></li>
            <li>{SITE.hours.join(" · ")}</li>
          </ul>
        </div>
      </div>
    </div>
    <p aria-hidden="true" className="font-display uppercase text-[16.5vw] leading-[0.8] tracking-[-0.05em] text-center text-[#FF5500] select-none translate-y-[12%]">
      Mister Pollo
    </p>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-400 border-t border-white/10">
      <span>© {new Date().getFullYear()} Mister Pollo · Volla (NA)</span>
      <Link to="/admin/login" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 hover:text-white transition-colors">
        <Lock className="w-3.5 h-3.5" /> Area riservata
      </Link>
    </div>
  </footer>
);
